export default __webpack_public_path__ + "static/media/close-circle-dark.5f55662a.svg";